import React, {Component} from 'react'
import propTypes from 'prop-types'
import {isNil} from 'lodash'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Divider from '@material-ui/core/Divider'
import BaseEditor from './baseEditor'
import Icon, {iconNames} from '../../../components/icon'
import {parseCssSelector} from 'helpers/css'
import {t} from "helpers/language"

class MultiListEditor extends Component {

  focusMenu = () => {
    if (this.menuList) this.menuList.focus()
  }

  toggleValue = (key, toggle) => {
    let {value} = this.props
    const {onCommit} = this.props
    if (isNil(value)) value = []

    if (toggle) {
      onCommit([...value, key], false)
    } else {
      onCommit(value.filter(v => v !== key), false)
    }
  }

  toggleAll = (toggle) => {
    const {values, onCommit, onCancel} = this.props
    const editedValues = toggle ? values.slice().map(v => v.key) : []
    onCommit(editedValues, false)
    onCancel()
  }

  isSelected = (item) => {
    const {value} = this.props
    return !isNil(value) && (value.indexOf(item.key) >= 0)
  }

  getMenuItem = (item) => {
    const {key, label, icon} = item

    const selected = this.isSelected(item)
    const iconEl = icon
      ? <Icon name={icon}/>
      : <Icon name={iconNames.tick} style={selected ? null : {visibility: 'hidden'}}/>

    return (
      <MenuItem
        className={parseCssSelector(label)}
        key={key}
        value={key}
        onClick={() => this.toggleValue(key, !selected)}
      >
        <ListItemIcon>{iconEl}</ListItemIcon>
        {label}
      </MenuItem>
    )
  }

  sortItems = (a, b) => {
    if (a.label > b.label) return 1
    if (a.label < b.label) return -1
    return 0
  }

  render() {
    const {open, anchor, values, onCancel, ...otherProps} = this.props

    const items = [...values].sort(this.sortItems)
    const isAllSelected = values.every(v => this.isSelected(v))
    const isAnySelected = values.some(v => this.isSelected(v))

    const menuItemHeight = 80
    let height = menuItemHeight + (values.length * 48)
    if (isAnySelected) {
      height += menuItemHeight
    }

    return (
      <BaseEditor
        open={open}
        anchor={anchor}
        {...otherProps} height={height}
        onClose={onCancel}
        onEntered={this.focusMenu}
        padded={false}
      >
        <MenuList
          className={'multi-list-editor-menu'}
          ref={e => {
            this.menuList = e
          }}>
          {items.map(v => this.getMenuItem(v))}
          <Divider key="_"/>
          <MenuItem
            key={'select-all-menu-item'}
            onClick={() => this.toggleAll(true)}
            value={'_'}
          >
            <ListItemIcon>
              <Icon name={iconNames.tick} style={isAllSelected ? null : {visibility: 'hidden'}}/>
            </ListItemIcon>
            {t('Select All')}
          </MenuItem>
          {isAnySelected &&
            <MenuItem
              key={'deselect-all-menu-item'}
              onClick={() => this.toggleAll(false)}
              value={'_'}
            >
              <ListItemIcon>
                <Icon name={iconNames.tick} style={{visibility: 'hidden'}}/>
              </ListItemIcon>
              {t('Deselect All')}
            </MenuItem>
          }
        </MenuList>
      </BaseEditor>
    )
  }
}

MultiListEditor.propTypes = {
  value: propTypes.array,
  open: propTypes.bool.isRequired,
  anchor: propTypes.object,
  values: propTypes.arrayOf(propTypes.shape({
    key: propTypes.any.isRequired,
    label: propTypes.string.isRequired,
  })).isRequired,
  onCommit: propTypes.func.isRequired,
  onCancel: propTypes.func.isRequired,
}

export default MultiListEditor
